import { render } from "./DataLoading.vue?vue&type=template&id=27707541&scoped=true"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"

import "./DataLoading.vue?vue&type=style&index=0&id=27707541&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27707541"]])

export default __exports__